<template>
  <NavBar />
  <div class="schedule-page">
    <main class="schedule-container">
      <section class="schedule-hero" aria-labelledby="schedule-welcome">
        <div class="hero-copy">
          <span class="hero-eyebrow"><i class="bi bi-stars" aria-hidden="true"></i> ÖĞRENME YOLCULUĞUN</span>
          <h2 id="schedule-welcome">Her ders, yeni bir adım.</h2>
          <p>İngilizcene zaman ayır, gelişimine yer aç.<br />Derslerini takip et ve sıradaki derse hazır ol.</p>
          <span class="hero-note"><i class="bi bi-calendar-check" aria-hidden="true"></i> Senin hızın, senin takvimin</span>
        </div>
        <img class="hero-calendar" :src="calendarImage" alt="" width="240" height="160" decoding="async" />
      </section>
      <TrainingCalender auto-scroll-to-lesson />
      <aside class="schedule-tip"><span class="tip-icon"><i class="bi bi-lightbulb" aria-hidden="true"></i></span><p><strong>Küçük bir hazırlık, büyük bir fark.</strong> Ders öncesinde materyallerine göz atarak öğrenmeye bir adım önde başla.</p></aside>
    </main>
  </div>
  <FooterInPage />
</template>

<script>
import NavBar from '@/components/Shared/NavBar.vue';
import FooterInPage from '@/components/Shared/FooterInPage.vue';
import TrainingCalender from '@/components/MyPage/training-calender.vue';
import calendarImage from '@/assets/images/education/dashboard/lesson-calendar.svg';
export default {
  name: 'LessonSchedule',
  components: { NavBar, FooterInPage, TrainingCalender },
  data() { return { calendarImage }; }
};
</script>

<style scoped>
.schedule-page { min-height: 70vh; background: radial-gradient(ellipse at 10% 0%, #edf7e8, transparent 45%), #f8fafc; color: #0f172a; -webkit-font-smoothing: antialiased; }
.schedule-container { max-width: 1024px; margin: 0 auto; padding: 32px 24px; }
.schedule-hero { display: flex; align-items: center; justify-content: space-between; gap: 24px; padding: 20px 30px; margin-bottom: 24px; border: 1px solid #dcebd5; border-radius: 24px; background: linear-gradient(115deg, #edf8e9, #f5faef 60%, #fff4df); overflow: hidden; }
.hero-copy { position: relative; z-index: 1; }
.hero-eyebrow { display: inline-flex; align-items: center; gap: 8px; color: #39782e; font-size: 11px; font-weight: 700; letter-spacing: 1.5px; }
.hero-eyebrow i { font-size: 18px; }
.hero-copy h2 { margin: 8px 0; font-size: clamp(24px, 3vw, 30px); font-weight: 750; letter-spacing: -.04em; color: #243b28; }
.hero-copy p { color: #53634f; font-size: 13px; line-height: 1.6; margin: 0; }
.hero-note { display: inline-flex; align-items: center; gap: 8px; margin-top: 12px; padding: 6px 10px; border: 1px solid #dcebd5; border-radius: 20px; background: #ffffffb3; color: #39782e; font-size: 12px; font-weight: 600; }
.hero-calendar { display: block; width: 240px; height: 160px; flex-shrink: 0; object-fit: contain; }
.schedule-tip { display: flex; align-items: center; gap: 14px; padding: 18px 22px; margin-top: 20px; background: #fff8e9; border: 1px solid #f1e4c5; border-radius: 16px; }
.tip-icon { display: grid; place-items: center; width: 38px; height: 38px; flex-shrink: 0; border-radius: 12px; background: #ffedbc; color: #876119; font-size: 20px; }
.schedule-tip p { margin: 0; font-size: 12px; line-height: 1.8; color: #79643f; }
.schedule-tip strong { display: block; color: #634b22; font-size: 13px; }
.schedule-container :deep(.schedule-card) { border-color: #e3ebde; box-shadow: 0 8px 32px #334d2710; }
.schedule-container :deep(.month-switcher) { background: #f1f7ed; border-color: #dfebd8; }
.schedule-container :deep(.view-switcher button[aria-pressed="true"]) { background: #e7f3df; color: #356d28; box-shadow: 0 2px 6px #356d2810; }
.schedule-container :deep(.lesson-card) { border-left: 4px solid #c9dcba; transition: transform .2s, box-shadow .2s, border-color .2s; }
.schedule-container :deep(.lesson-card:hover) { transform: translateY(-2px); border-color: #b7d4a6; box-shadow: 0 6px 18px #334d2710; }
.schedule-container :deep(.date-badge) { background: #edf5e6; color: #477536; }
.schedule-container :deep(.lesson-card.is-today) { background: #f3faed; border-color: #8fc978; }
.schedule-container :deep(.lesson-card.is-today .date-badge) { background: var(--brand-primary, #55b948); color: #fff; }
.schedule-container :deep(.lesson-card.is-completed) { border-left-color: #b9cde8; }
.schedule-container :deep(.lesson-card.is-completed .date-badge) { background: #edf2fc; color: #536d96; }
.schedule-container :deep(.status-next) { background: #e3f1d8; color: #356d28; }
.schedule-container :deep(.calendar-day.has-lessons) { background: #f0f8e9; border-color: #c6dfb5; }
.schedule-container :deep(.calendar-day[aria-pressed="true"]) { background: #e3f1d8; border-color: #649e4d; box-shadow: 0 0 0 2px #649e4d26; }
.schedule-container :deep(.empty-state) { background: linear-gradient(135deg, #f6faf2, #fff); border-color: #dce8d3; }
@media (max-width: 639px) {
  .schedule-container { padding: 24px 16px; }
  .schedule-hero { padding: 18px 20px; gap: 8px; flex-direction: column; align-items: flex-start; }
  .schedule-tip { padding: 16px; align-items: flex-start; }
}
@media (max-width: 767px) {
  .hero-calendar { display: none; }
}
@media (prefers-reduced-motion: reduce) {
  .schedule-container :deep(.lesson-card) { transition: none; }
  .schedule-container :deep(.lesson-card:hover) { transform: none; }
}
</style>
